import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { take, catchError } from 'rxjs/operators'
import { Division } from './models/Division';
import TruckDivision from './models/TruckDivision';
import Truck from './models/Truck';
@Injectable({
    providedIn: 'root'
})

export class DivisionManagementService {
    constructor(private httpClient: HttpClient) { }

    getCurrentUserDivision(): Division | null {
        const userCurrentDivisionJson = localStorage.getItem("userCurrentDivision")

        if (userCurrentDivisionJson) {
            return JSON.parse(userCurrentDivisionJson);
        }

        return null;
    }
}
